import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled"]

import { computed, type CSSProperties } from 'vue';
import { Loader2, Check } from 'lucide-vue-next';
import { cn } from '@/lib/utils';

type Variant = 'primary' | 'secondary' | 'inverted' | 'ghost';
type Size = 'sm' | 'md' | 'lg' | 'buyButton';
type State = 'idle' | 'pending' | 'success' | 'error' | 'disabled';


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    state: { default: 'idle' },
    type: { default: 'button' },
    successColor: {}
  },
  setup(__props: any) {

const props = __props;

const variantClasses: Record<Variant, string> = {
  primary: 'bg-primary text-primary-foreground hover:opacity-90',
  secondary: 'bg-secondary text-secondary-foreground hover:opacity-90',
  inverted:
    'bg-background text-foreground border border-foreground/20 hover:bg-foreground hover:text-background',
  ghost: 'bg-transparent hover:bg-foreground/5',
};

const sizeClasses: Record<Size, string> = {
  sm: 'h-9 px-3 text-sm',
  md: 'h-10 px-4',
  lg: 'h-12 px-6 text-lg',
  buyButton: 'h-11 px-8 text-sm'
};

const stateClasses = computed(() => (props.state === 'error' ? 'animate-shake' : ''));

const inlineStyle = computed<CSSProperties>(() => {
  if (props.state === 'success' && props.successColor) {
    return { backgroundColor: props.successColor };
  }
  return {};
});

const isDisabled = computed(() => props.state === 'pending' || props.state === 'disabled');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: _ctx.type,
    disabled: isDisabled.value,
    style: _normalizeStyle(inlineStyle.value),
    class: _normalizeClass(
      _unref(cn)(
        'inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed',
        variantClasses[_ctx.variant],
        sizeClasses[_ctx.size],
        stateClasses.value,
      )
    )
  }, [
    (_ctx.state === 'pending')
      ? (_openBlock(), _createBlock(_unref(Loader2), {
          key: 0,
          class: "h-4 w-4 animate-spin"
        }))
      : (_ctx.state === 'success')
        ? (_openBlock(), _createBlock(_unref(Check), {
            key: 1,
            class: "h-4 w-4"
          }))
        : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 14, _hoisted_1))
}
}

})